import React, {useEffect, useState} from 'react';
import {Title} from "../../components/base/Title";
import {parseToCurrency} from "../../context/panier-context";
import Section from "../../components/base/Section";
import {
	filtersStatutLivraison,
	getColorStatutLivraison,
	getStatutLivraison,
} from "../../utils/utils";
import {Badge} from "../../components/base/Badge";
import {getPaniersHistorique, HistoriquePanier, Panier} from "../../services/apiPanier";
import {handleApiError} from 'utils/errorHandlers';
import {ApiLoading} from 'components/ApiLoading';
import {DataTable} from "../../components/base/DataTable";
import {Produit} from "../../services/apiProduits";
import {Dialog} from "../../components/base/Dialog";
import { usePanier } from '../../context/panier-context';
import { useNavigate } from 'react-router-dom';

export const HistoriqueCommande: React.FC = () => {
	const { dupliquerPanier } = usePanier();
	const [historiquePanier, setHistoriquePanier] = useState<HistoriquePanier[]>([]);
	const [loading, setLoading] = useState(true);
	const [errors, setErrors] = useState<Record<string, string[]>>({});
	const [produits, setProduits] = useState<Produit[]>([]);
	const [open, setOpen] = useState<boolean>(false);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchHistorique = async () => {
			try {
				const historique = await getPaniersHistorique();
				setHistoriquePanier(historique);
			} catch (err) {
				setErrors(handleApiError(err));
			} finally {
				setLoading(false);
			}
		};

		fetchHistorique();
	}, []);

	if (errors && errors.general) {
		return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
	}

	if (loading) {
		return <ApiLoading type="loading">Chargement de l'historique...</ApiLoading>;
	}

	if (historiquePanier.length === 0) {
		return <ApiLoading type="no-data">Aucune commande trouvée</ApiLoading>;
	}

	const handleCommander = (row: HistoriquePanier) => {
		dupliquerPanier(row.produits);
		navigate('/panier');
	}

	return (
		<>
			<Title type="h2" className="mb-4">Historique des commandes</Title>
			<DataTable
				columns={[
					{key: 'dateLivraison', label: 'Date de livraison', sortable: true},
					{
						key: 'statut', label: 'Statut',
						render: (value) => <Badge bgColor={getColorStatutLivraison(value)}>{getStatutLivraison(value)}</Badge>,
						filterOptions: filtersStatutLivraison()
					},
					{key: 'referent_nom_complet', label: 'Référent'},
					{key: 'nbProduits', label: 'Nb Produits'},
					{key: 'total', label: 'Total', render: (value) => parseToCurrency(value)},
				]}
				data={historiquePanier}
				actions={[
					{
						label: 'Détail', buttonVariant: "secondary", onClick: (row) => {
							setProduits(row.produits);
							setOpen(true);
						}
					},
					{
						label: 'Commander à nouveau', buttonVariant: "primary", onClick: (row) => {
							handleCommander(row);
						},
					},
				]}
				actionWidth='w-[310px]'
			/>
			<Dialog open={open} noConfirmBtn onClose={() => {
				setOpen(false)
			}}>
				<DataTable
					columns={[
						{key: 'libelle', label: 'Produit'},
						{key: 'quantite', label: 'Quantité'}
					]}
					data={produits}
				/>
			</Dialog>
		</>
	);
};